import { render, staticRenderFns } from "./BonusAndBalance.vue?vue&type=template&id=5c4bf7ea&scoped=true"
import script from "./BonusAndBalance.vue?vue&type=script&lang=js"
export * from "./BonusAndBalance.vue?vue&type=script&lang=js"
import style0 from "./BonusAndBalance.vue?vue&type=style&index=0&id=5c4bf7ea&lang=scss&scoped=true"
import style1 from "./BonusAndBalance.vue?vue&type=style&index=1&id=5c4bf7ea&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4bf7ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c4bf7ea')) {
      api.createRecord('5c4bf7ea', component.options)
    } else {
      api.reload('5c4bf7ea', component.options)
    }
    module.hot.accept("./BonusAndBalance.vue?vue&type=template&id=5c4bf7ea&scoped=true", function () {
      api.rerender('5c4bf7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/vertical/BonusAndBalance.vue"
export default component.exports